export const getSortedList = (list = [], type = 'string', increse = true, fieldName = 'name') => {
  if (type === 'number') {
    if (increse) {
      return list.toSorted((a, b) => a[fieldName] - b[fieldName])
    } else {
      return list.toSorted((a, b) => b[fieldName] - a[fieldName])
    }
  }

  return list
}
